export default __webpack_public_path__ + "static/media/celestialgaze.092fb0e0.png";